export interface CalendarioHitosTranslations {
  LABELS: {
    MORE: string;
    HITO: string;
    DIA_INHABIL: string;
    CALENDARIO_TITULO: string;
    DETALLE_DIA: string;
    DETALLE_HITO: string;
  };

  [key: string]: any;
}

export const calendarioHitosTranslations: { [language: string]: CalendarioHitosTranslations } = {
  en: {
    LABELS: {
      MORE: 'More...',
      HITO: 'Milestone',
      DIA_INHABIL: 'Non-working day',
      CALENDARIO_TITULO: 'Milestone calendar',
      DETALLE_DIA: 'Day detail',
      DETALLE_HITO: 'Milestone detail'
    },
  },
  es: {
    LABELS: {
      MORE: 'Más...',
      HITO: 'Hito',
      DIA_INHABIL: 'Día inhábil',
      CALENDARIO_TITULO: 'Calendario de hitos',
      DETALLE_DIA: 'Detalle del día',
      DETALLE_HITO: 'Detalle del hito'
    },
  }
};
